// Suivi anonyme de la source de visite (première source de la visite, stockée dans l'onglet uniquement)
const KEY = 'ledzone_visit_attr';
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];

const randomId = () => Array.from(crypto.getRandomValues(new Uint8Array(12)), (b) => b.toString(16).padStart(2, '0')).join('');

export const captureAttribution = () => {
  try {
    if (sessionStorage.getItem(KEY)) return;
    const q = new URLSearchParams(window.location.search);
    let referrerHost = '';
    try { referrerHost = document.referrer ? new URL(document.referrer).hostname : ''; } catch { referrerHost = ''; }
    if (referrerHost === window.location.hostname) referrerHost = '';
    const attribution = { referrer_host: referrerHost };
    PARAMS.forEach((p) => { if (q.get(p)) attribution[p] = q.get(p).slice(0, 80); });
    ['fbclid', 'ttclid', 'gclid'].forEach((p) => { if (q.get(p)) attribution[p] = '1'; });
    sessionStorage.setItem(KEY, JSON.stringify({ visit_id: randomId(), attribution }));
  } catch { /* stockage indisponible : suivi ignoré */ }
};

export const getVisit = () => {
  try { return JSON.parse(sessionStorage.getItem(KEY)) || null; } catch { return null; }
};

export const trackPromo = (event, extra = {}) => {
  const visit = getVisit();
  if (!visit) return;
  fetch(`${BACKEND_URL}/api/promo-track`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, keepalive: true,
    body: JSON.stringify({ event, visit_id: visit.visit_id, attribution: visit.attribution, ...extra }),
  }).catch(() => {});
};
